"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EDistributionFrequencyTrads = void 0;
exports.EDistributionFrequencyTrads = {
    monthly: "Mensuelle",
    quarterly: "Trimestrielle",
    annual: "Annuelle",
    semi_annual: "Semestrielle",
    no_payout: "Pas de versement",
    monthly_or_quarterly: "Mensuelle ou Trimestrielle",
    capitalization: "Capitalisation",
};
